import {HIDE_MESSAGE} from "../constants/Message";

export const hideMessage = () => async dispatch =>dispatch({type: HIDE_MESSAGE})